var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "feesForStopForm",
      staticClass: "fees-for-stop-form",
      attrs: {
        model: _vm.model,
        rules: _vm.rules,
        "label-width": "12em",
        "label-position": "left"
      }
    },
    [
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("BillingYm", {
            attrs: {
              required: true,
              searchCond: true,
              mode: _vm.billingYmMode,
              disabled: _vm.editMode,
              autofocus: !_vm.editMode
            },
            model: {
              value: _vm.billingYm,
              callback: function($$v) {
                _vm.billingYm = $$v
              },
              expression: "billingYm"
            }
          }),
          _c("BillToCode", {
            attrs: {
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              disabled: _vm.editMode,
              "autocomplete-list": _vm.autocompleteCustomerCodeSet
            },
            model: {
              value: _vm.billToCode,
              callback: function($$v) {
                _vm.billToCode = $$v
              },
              expression: "billToCode"
            }
          })
        ],
        1
      ),
      _c("el-divider"),
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("ActionType", {
            attrs: {
              label: "着離陸・入出庫区分",
              required: !_vm.searchMode,
              disabled: _vm.editMode,
              mode: "normal"
            },
            on: {
              change: function($event) {
                return _vm.changeActionType($event)
              }
            },
            model: {
              value: _vm.actionType,
              callback: function($$v) {
                _vm.actionType = $$v
              },
              expression: "actionType"
            }
          }),
          _c("RegistrationSymbol", {
            attrs: {
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              disabled: _vm.editMode,
              "autocomplete-list": _vm.autocompleteRegistrationSymbolSet
            },
            model: {
              value: _vm.registrationSymbol,
              callback: function($$v) {
                _vm.registrationSymbol = $$v
              },
              expression: "registrationSymbol"
            }
          })
        ],
        1
      ),
      _vm.formMode === "search"
        ? [
            _c("DateTimeRange", {
              attrs: {
                dateTimeFrom: _vm.actionTimeFrom,
                dateTimeTo: _vm.actionTimeTo,
                label: "着離陸・入出庫日時",
                prop: "action_time",
                required: !_vm.searchMode,
                searchCond: _vm.searchMode,
                mode: "normal",
                disabled: _vm.editMode
              },
              on: {
                "update:dateTimeFrom": function($event) {
                  _vm.actionTimeFrom = $event
                },
                "update:date-time-from": function($event) {
                  _vm.actionTimeFrom = $event
                },
                "update:dateTimeTo": function($event) {
                  _vm.actionTimeTo = $event
                },
                "update:date-time-to": function($event) {
                  _vm.actionTimeTo = $event
                }
              }
            })
          ]
        : [
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("DateTime", {
                  attrs: {
                    label: "着離陸・入出庫日時",
                    prop: "action_time",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    mode: "normal",
                    disabled: _vm.editMode
                  },
                  model: {
                    value: _vm.actionTime,
                    callback: function($$v) {
                      _vm.actionTime = $$v
                    },
                    expression: "actionTime"
                  }
                }),
                _vm.editDisabledMode && !_vm.searchMode
                  ? [
                      _vm.actionType === "1" || _vm.actionType === "8"
                        ? [
                            _vm.actionType === "1"
                              ? [
                                  _c("BillingExclusion", {
                                    attrs: {
                                      label: "請求除外",
                                      prop: "billing_exclusion_flag",
                                      initialize: true,
                                      placeholder: "請求除外時のみ選択",
                                      clearable: true,
                                      disabled: _vm.editMode,
                                      codeId: "BILLING_EXCLUSION_ARR"
                                    },
                                    model: {
                                      value: _vm.billingExclusion,
                                      callback: function($$v) {
                                        _vm.billingExclusion = $$v
                                      },
                                      expression: "billingExclusion"
                                    }
                                  })
                                ]
                              : _vm._e(),
                            _vm.actionType === "8"
                              ? [
                                  _c("BillingExclusion", {
                                    attrs: {
                                      label: "請求除外",
                                      prop: "billing_exclusion_flag",
                                      initialize: true,
                                      placeholder: "請求除外時のみ選択",
                                      clearable: true,
                                      disabled: _vm.editMode,
                                      codeId: "BILLING_EXCLUSION_DEP"
                                    },
                                    model: {
                                      value: _vm.billingExclusion,
                                      callback: function($$v) {
                                        _vm.billingExclusion = $$v
                                      },
                                      expression: "billingExclusion"
                                    }
                                  })
                                ]
                              : _vm._e()
                          ]
                        : [_c("Blank")]
                    ]
                  : [_c("Blank")]
              ],
              2
            )
          ],
      _vm.formMode === "search" ||
      (!_vm.searchMode && (_vm.actionType === "1" || _vm.actionType === "8"))
        ? [
            _c("el-divider"),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Callsign", {
                  attrs: {
                    searchCond: _vm.searchMode,
                    initialize: true,
                    required: !_vm.searchMode,
                    disabled: _vm.editDisabledMode && _vm.editMode
                  },
                  model: {
                    value: _vm.callsign,
                    callback: function($$v) {
                      _vm.callsign = $$v
                    },
                    expression: "callsign"
                  }
                }),
                _c("RouteCode", {
                  attrs: {
                    searchCond: _vm.searchMode,
                    initialize: true,
                    required: !_vm.searchMode,
                    disabled: _vm.editDisabledMode && _vm.editMode
                  },
                  model: {
                    value: _vm.routeCode,
                    callback: function($$v) {
                      _vm.routeCode = $$v
                    },
                    expression: "routeCode"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("AirportCode", {
                  staticClass: "departure_airport_code",
                  attrs: {
                    label: "出発地",
                    prop: "departure_airport_code",
                    searchCond: _vm.searchMode,
                    initialize: true,
                    "autocomplete-list": _vm.autocompleteAirportCodeSet,
                    disabled:
                      (_vm.actionType === "8" && !_vm.searchMode) ||
                      (_vm.editDisabledMode && _vm.editMode),
                    required: !_vm.searchMode
                  },
                  model: {
                    value: _vm.departureAirportCode,
                    callback: function($$v) {
                      _vm.departureAirportCode = $$v
                    },
                    expression: "departureAirportCode"
                  }
                }),
                _c("AirportCode", {
                  staticClass: "destination_airport_code",
                  attrs: {
                    label: "目的地",
                    prop: "destination_airport_code",
                    searchCond: _vm.searchMode,
                    initialize: true,
                    "autocomplete-list": _vm.autocompleteAirportCodeSet,
                    disabled:
                      (_vm.actionType === "1" && !_vm.searchMode) ||
                      (_vm.editDisabledMode && _vm.editMode),
                    required: !_vm.searchMode
                  },
                  model: {
                    value: _vm.destinationAirportCode,
                    callback: function($$v) {
                      _vm.destinationAirportCode = $$v
                    },
                    expression: "destinationAirportCode"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("FlightPurposeCode", {
                  attrs: {
                    searchCond: _vm.searchMode,
                    required: !_vm.searchMode,
                    initialize: true,
                    disabled: _vm.editDisabledMode && _vm.editMode
                  },
                  model: {
                    value: _vm.flightPurposeCode,
                    callback: function($$v) {
                      _vm.flightPurposeCode = $$v
                    },
                    expression: "flightPurposeCode"
                  }
                }),
                _c("Blank")
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.formMode === "search" || _vm.formMode === "edit"
        ? [
            _c("el-divider"),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("ModelCode", {
                  attrs: {
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    disabled: _vm.editMode,
                    initialize: true,
                    "autocomplete-list": _vm.autocompleteModelCodeSet
                  },
                  model: {
                    value: _vm.modelCode,
                    callback: function($$v) {
                      _vm.modelCode = $$v
                    },
                    expression: "modelCode"
                  }
                }),
                _c("AircraftType", {
                  attrs: {
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    disabled: _vm.editMode,
                    initialize: true
                  },
                  model: {
                    value: _vm.aircraftType,
                    callback: function($$v) {
                      _vm.aircraftType = $$v
                    },
                    expression: "aircraftType"
                  }
                })
              ],
              1
            ),
            _vm.formMode === "search"
              ? [
                  _c(
                    "div",
                    { staticClass: "el-form--inline" },
                    [
                      _c("Numeric", {
                        attrs: {
                          label: "重量[t]",
                          prop: "weight",
                          required: !_vm.searchMode,
                          searchCond: _vm.searchMode,
                          min: 0.1,
                          max: 999.9,
                          precision: 1,
                          step: 0.1,
                          disabled: _vm.editDisabledMode && _vm.editMode
                        },
                        model: {
                          value: _vm.weight,
                          callback: function($$v) {
                            _vm.weight = $$v
                          },
                          expression: "weight"
                        }
                      }),
                      _c("Blank")
                    ],
                    1
                  )
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "el-form--inline" },
                    [
                      _c("Numeric", {
                        attrs: {
                          label: "重量[t]",
                          placeholder: "0.1～999.9",
                          prop: "weight",
                          required: !_vm.searchMode,
                          searchCond: _vm.searchMode,
                          min: 0.1,
                          max: 999.9,
                          precision: 1,
                          step: 0.1,
                          disabled: _vm.editDisabledMode && _vm.editMode
                        },
                        model: {
                          value: _vm.weight,
                          callback: function($$v) {
                            _vm.weight = $$v
                          },
                          expression: "weight"
                        }
                      }),
                      _c("Blank")
                    ],
                    1
                  )
                ]
          ]
        : _vm._e(),
      _vm.formMode === "search" || (!_vm.searchMode && _vm.actionType === "8")
        ? [
            _c("el-divider"),
            _vm.formMode === "search"
              ? [
                  _c(
                    "div",
                    { staticClass: "el-form--inline" },
                    [
                      _c("Numeric", {
                        attrs: {
                          label: "停留回数",
                          prop: "stops",
                          required: !_vm.searchMode,
                          searchCond: _vm.searchMode,
                          min: 0,
                          max: 999,
                          step: 1,
                          disabled: _vm.editDisabledMode && _vm.editMode
                        },
                        model: {
                          value: _vm.stops,
                          callback: function($$v) {
                            _vm.stops = $$v
                          },
                          expression: "stops"
                        }
                      }),
                      _c("Numeric", {
                        attrs: {
                          label: "停留時間[分]",
                          prop: "stop_minutes",
                          required: !_vm.searchMode,
                          searchCond: _vm.searchMode,
                          min: 0,
                          max: 999999,
                          step: 1,
                          disabled: _vm.editDisabledMode && _vm.editMode
                        },
                        model: {
                          value: _vm.stopMinutes,
                          callback: function($$v) {
                            _vm.stopMinutes = $$v
                          },
                          expression: "stopMinutes"
                        }
                      })
                    ],
                    1
                  )
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "el-form--inline" },
                    [
                      _c("Numeric", {
                        attrs: {
                          label: "停留回数",
                          placeholder: "0～999",
                          prop: "stops",
                          required: !_vm.searchMode,
                          searchCond: _vm.searchMode,
                          min: 0,
                          max: 999,
                          step: 1,
                          disabled: _vm.editDisabledMode && _vm.editMode
                        },
                        model: {
                          value: _vm.stops,
                          callback: function($$v) {
                            _vm.stops = $$v
                          },
                          expression: "stops"
                        }
                      }),
                      _c("Numeric", {
                        attrs: {
                          label: "停留時間[分]",
                          placeholder: "0～999999",
                          prop: "stop_minutes",
                          required: !_vm.searchMode,
                          searchCond: _vm.searchMode,
                          min: 0,
                          max: 999999,
                          step: 1,
                          disabled: _vm.editDisabledMode && _vm.editMode
                        },
                        model: {
                          value: _vm.stopMinutes,
                          callback: function($$v) {
                            _vm.stopMinutes = $$v
                          },
                          expression: "stopMinutes"
                        }
                      })
                    ],
                    1
                  )
                ],
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Taxation", {
                  attrs: {
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    initialize: true,
                    disabled: _vm.editDisabledMode && _vm.editMode
                  },
                  model: {
                    value: _vm.taxation,
                    callback: function($$v) {
                      _vm.taxation = $$v
                    },
                    expression: "taxation"
                  }
                }),
                _vm.formMode === "search"
                  ? [
                      _c("Numeric", {
                        attrs: {
                          label: "税率[%]",
                          prop: "tax",
                          required: !_vm.searchMode,
                          disabled: _vm.editMode,
                          searchCond: _vm.searchMode,
                          min: 0,
                          max: 99,
                          step: 1
                        },
                        model: {
                          value: _vm.tax,
                          callback: function($$v) {
                            _vm.tax = $$v
                          },
                          expression: "tax"
                        }
                      })
                    ]
                  : _vm.formMode === "edit"
                  ? [
                      _c("Numeric", {
                        attrs: {
                          label: "税率[%]",
                          placeholder: "0～99",
                          prop: "tax",
                          required: !_vm.searchMode,
                          disabled: _vm.editMode,
                          searchCond: _vm.searchMode,
                          min: 0,
                          max: 99,
                          step: 1
                        },
                        model: {
                          value: _vm.tax,
                          callback: function($$v) {
                            _vm.tax = $$v
                          },
                          expression: "tax"
                        }
                      })
                    ]
                  : [_c("Blank")]
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Numeric", {
                  attrs: {
                    label: "単位料金[円]",
                    prop: "unit_fee",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    min: 0,
                    max: 9999999,
                    disabled: _vm.editDisabledMode && _vm.editMode
                  },
                  model: {
                    value: _vm.unitFee,
                    callback: function($$v) {
                      _vm.unitFee = $$v
                    },
                    expression: "unitFee"
                  }
                }),
                _c("Numeric", {
                  attrs: {
                    label: "停留料(税抜)[円]",
                    prop: "stop_fee_without_tax",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    min: -9999999,
                    max: 9999999,
                    disabled: _vm.editDisabledMode && _vm.editMode
                  },
                  model: {
                    value: _vm.stopFeeWithoutTax,
                    callback: function($$v) {
                      _vm.stopFeeWithoutTax = $$v
                    },
                    expression: "stopFeeWithoutTax"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Numeric", {
                  attrs: {
                    label: "停留料(税)[円]",
                    prop: "stop_fee_tax",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    min: -9999999,
                    max: 9999999,
                    disabled: _vm.editDisabledMode && _vm.editMode
                  },
                  model: {
                    value: _vm.stopFeeTax,
                    callback: function($$v) {
                      _vm.stopFeeTax = $$v
                    },
                    expression: "stopFeeTax"
                  }
                }),
                _c("Numeric", {
                  attrs: {
                    label: "停留料(税込)[円]",
                    prop: "stop_fee_with_tax",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    min: -9999999,
                    max: 9999999,
                    disabled: _vm.editDisabledMode && _vm.editMode
                  },
                  model: {
                    value: _vm.stopFeeWithTax,
                    callback: function($$v) {
                      _vm.stopFeeWithTax = $$v
                    },
                    expression: "stopFeeWithTax"
                  }
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.formMode === "search"
        ? [
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Blank"),
                _c("div", { staticClass: "parent_Box" }, [
                  _c(
                    "div",
                    { staticClass: "child_Box" },
                    [
                      _vm.searchMode
                        ? _c(
                            "el-checkbox",
                            {
                              attrs: { searchCond: _vm.searchMode },
                              model: {
                                value: _vm.manualDataOnly,
                                callback: function($$v) {
                                  _vm.manualDataOnly = $$v
                                },
                                expression: "manualDataOnly"
                              }
                            },
                            [_vm._v("検索結果に補正登録データのみ表示する")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "child_Box" },
                    [
                      _vm.searchMode
                        ? _c(
                            "el-checkbox",
                            {
                              attrs: { searchCond: _vm.searchMode },
                              model: {
                                value: _vm.automaticDataOnly,
                                callback: function($$v) {
                                  _vm.automaticDataOnly = $$v
                                },
                                expression: "automaticDataOnly"
                              }
                            },
                            [_vm._v("検索結果に自動入力データのみ表示する")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }